import { getUserProperties, isOnboardingEmbedExperienceV2Enabled, } from '@thoughtspot/session-service';
import React from 'react';
import { createContainer } from 'react-tracked';
export const INTENT_PATH_CONTEXT_KEY = 'intentPathSelected';
export const PATH_SEQUENCE_CONTEXT_KEY = 'pathSequence';
export const INTENT_PATH_NOT_APPLICABLE = 'NA';
const EMBED_EXPERIENCE = 'embed';
export var OnboardingJobFunction;
(function (OnboardingJobFunction) {
    OnboardingJobFunction["DATA_ANALYTICS"] = "data-analytics";
    OnboardingJobFunction["PRODUCT_MANAGEMENT"] = "product-management";
    OnboardingJobFunction["SALES_ACCOUNT_MANAGEMENT"] = "sales-account-management";
    OnboardingJobFunction["MARKETING_GROWTH"] = "marketing-growth";
    OnboardingJobFunction["FINANCE_ACCOUNTING"] = "finance-accounting";
    OnboardingJobFunction["EXECUTIVE_LEADERSHIP"] = "executive-leadership";
    OnboardingJobFunction["SOFTWARE_ENGINEERING"] = "software-engineering";
    OnboardingJobFunction["STUDENT"] = "student";
})(OnboardingJobFunction || (OnboardingJobFunction = {}));
export const DEFAULT_SPOTBUILD_IDS = {
    LIVEBOARD: 'd084c256-e284-4fc4-b80c-111cb606449a',
    MODEL: 'cd252e5c-b552-49a8-821d-3eadaa049cca',
    TABLES: [
        '7d174ef2-2482-4e61-9d6e-1e1d709d96b0',
        'a633dccd-b449-46df-a0fc-92034d6858cb',
        '757f2434-66ef-43ad-9820-ba9008072155',
    ],
};
export var MilestoneAgentName;
(function (MilestoneAgentName) {
    MilestoneAgentName["NONE"] = "NONE";
    MilestoneAgentName["SPOTTER_CHAT"] = "SPOTTER_CHAT";
    MilestoneAgentName["SPOTTER_VIZ"] = "SPOTTER_VIZ";
    MilestoneAgentName["SPOTTER_CODE"] = "SPOTTER_CODE";
})(MilestoneAgentName || (MilestoneAgentName = {}));
export var MilestoneStatus;
(function (MilestoneStatus) {
    MilestoneStatus["NONE"] = "NONE";
    MilestoneStatus["STARTED"] = "STARTED";
    MilestoneStatus["FINISHED"] = "FINISHED";
})(MilestoneStatus || (MilestoneStatus = {}));
export const getOnboardingRoleSelections = (isMTServicesEnabled, savedRole) => {
    var _a;
    const userProperties = getUserProperties();
    const sparkflowFunction = isMTServicesEnabled
        ? savedRole === null || savedRole === void 0 ? void 0 : savedRole.function
        : userProperties === null || userProperties === void 0 ? void 0 : userProperties.function;
    const sparkflowIndustry = isMTServicesEnabled
        ? savedRole === null || savedRole === void 0 ? void 0 : savedRole.industry
        : userProperties === null || userProperties === void 0 ? void 0 : userProperties.industry;
    return {
        ...((_a = savedRole === null || savedRole === void 0 ? void 0 : savedRole.onboardingContext) !== null && _a !== void 0 ? _a : {}),
        selectedFunction: sparkflowFunction || '',
        selectedIndustry: sparkflowIndustry || '',
    };
};
export const hasSparkflowEmbedIntent = (selectedFunction) => {
    if (!selectedFunction) {
        return getUserProperties().experience === EMBED_EXPERIENCE;
    }
    return selectedFunction === OnboardingJobFunction.SOFTWARE_ENGINEERING;
};
export var SparkflowBlinkActionType;
(function (SparkflowBlinkActionType) {
    SparkflowBlinkActionType[SparkflowBlinkActionType["UPDATE_SPARKFLOW_GLOBAL_CONTEXT"] = 0] = "UPDATE_SPARKFLOW_GLOBAL_CONTEXT";
    SparkflowBlinkActionType[SparkflowBlinkActionType["REQUEST_CHECKLIST_REFRESH"] = 1] = "REQUEST_CHECKLIST_REFRESH";
    SparkflowBlinkActionType[SparkflowBlinkActionType["UPDATE_MILESTONE"] = 2] = "UPDATE_MILESTONE";
})(SparkflowBlinkActionType || (SparkflowBlinkActionType = {}));
export const defaultSparkflowContextOptions = {
    hideSparkflowBanner: false,
    spotterVizConfig: {
        prefilledSampleQuestions: undefined,
        starterPrompts: undefined,
    },
    spotbuildGenResponse: [],
    savedRole: undefined,
    isLoadingIndicatorVisible: false,
    checklistRefreshRequested: false,
    lastOpenedChecklistSectionId: undefined,
    guidedFollowUpsOwned: false,
    guidedSpotterTourClosed: false,
    spotterConversationResetKey: undefined,
    milestone: {
        isModalOpen: false,
        agentName: MilestoneAgentName.NONE,
        status: MilestoneStatus.NONE,
        earnedByTour: false,
    },
    isGeneratedIdsLoading: true,
    sparkflowPinboardId: null,
    checklistReopenAfterNavigation: false,
    checklistNavigationUrl: undefined,
    checklistReopenRequested: false,
    isLiveboardEditMode: false,
};
const reducer = (state = defaultSparkflowContextOptions, action) => {
    switch (action.type) {
        case SparkflowBlinkActionType.UPDATE_SPARKFLOW_GLOBAL_CONTEXT:
            return { ...state, ...action.data };
        case SparkflowBlinkActionType.REQUEST_CHECKLIST_REFRESH:
            return { ...state, ...action.data };
        case SparkflowBlinkActionType.UPDATE_MILESTONE:
            return {
                ...state,
                milestone: {
                    ...state.milestone,
                    ...action.data,
                },
            };
        default:
            return state;
    }
};
const getDispatcherFunctions = (dispatch) => ({
    updateSparkflowGlobalContext: (data) => {
        dispatch({
            type: SparkflowBlinkActionType.UPDATE_SPARKFLOW_GLOBAL_CONTEXT,
            data,
        });
    },
    requestChecklistRefresh: (data) => {
        dispatch({
            type: SparkflowBlinkActionType.REQUEST_CHECKLIST_REFRESH,
            data,
        });
    },
    updateMilestone: (data) => {
        dispatch({
            type: SparkflowBlinkActionType.UPDATE_MILESTONE,
            data,
        });
    },
});
function getOrCreateContainer() {
    var _a;
    if ((_a = window === null || window === void 0 ? void 0 : window.blink) === null || _a === void 0 ? void 0 : _a.sparkflowBlinkContainer) {
        return window.blink.sparkflowBlinkContainer;
    }
    const { Provider, useTrackedState, useUpdate } = createContainer(({ initialState }) => React.useReducer(reducer, initialState));
    const container = {
        Provider,
        useTrackedState,
        useDispatch: useUpdate,
    };
    window.blink = window.blink || {};
    window.blink.sparkflowBlinkContainer = container;
    return container;
}
const { Provider: InternalProvider, useTrackedState, useDispatch, } = getOrCreateContainer();
const SparkflowContextProvider = ({ children, value = {}, }) => (React.createElement(InternalProvider, { initialState: { ...defaultSparkflowContextOptions, ...value } }, children));
const getSparkflowGlobalContext = () => {
    try {
        return useTrackedState() || defaultSparkflowContextOptions;
    }
    catch (e) {
        if (/Please use <Provider>/.test(e === null || e === void 0 ? void 0 : e.message)) {
            return {};
        }
        throw e;
    }
};
const setSparkflowGlobalContext = () => {
    const dispatch = useDispatch();
    return dispatch
        ? getDispatcherFunctions(dispatch)
        : {};
};
const useIsSparkflowSpotterCodeEnabled = () => isOnboardingEmbedExperienceV2Enabled() && hasSparkflowEmbedIntent();
export { SparkflowContextProvider, getSparkflowGlobalContext, setSparkflowGlobalContext, useIsSparkflowSpotterCodeEnabled, };
//# sourceMappingURL=sparkflow-context.js.map